import { IGuideTemplate } from '@/types/components/ITemplate'
import { MarkdownContent } from '../../MarkdownContent'

interface GuideProps {
  template: IGuideTemplate
}

/**
 * To be used also for `Insights`.
 */
export const Guide = ({ template: { content } }: GuideProps) => {
  return (
    <div className='flex w-full justify-center'>
      <div className='relative mx-6 mb-16 w-full max-w-[800px] sm:mx-12'>
        <MarkdownContent increasedMargins>{content}</MarkdownContent>
      </div>
    </div>
  )
}
